import { render, staticRenderFns } from "./UpdateVisio.vue?vue&type=template&id=06b9c932"
import script from "./UpdateVisio.vue?vue&type=script&lang=js"
export * from "./UpdateVisio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports